export const projects = [
  {
    slug: "stenka-shkaf",
    title: "Стенка шкаф",
    preview: "https://s4.iimage.su/s/26/uwAolMZxzCGBKyYKKeWOwlZhJ48QFjpgQun8DqLB.webp",
    category: "model",
  description: "Корпус ЛДСП, фасады и видимые части корпуса МДФ+эмаль, столешница МДФ+шпон",
  modelImages: [ "https://s4.iimage.su/s/26/th_uYQkkQKxH3QrQmAuqBRqShm4y7VHLKO5faL8HAd2.webp","https://s4.iimage.su/s/26/th_u7RFHqcxy8RbFAzREQEk3Wq7Eh2HRlQ4oIUbzT3p.webp", "https://s4.iimage.su/s/26/uwAolMZxzCGBKyYKKeWOwlZhJ48QFjpgQun8DqLB.webp", "https://i.yapx.ru/cvneZ.jpg", "https://i.yapx.ru/cvnT1.jpg", "https://i.yapx.ru/cvnW6.jpg"]
  ,  measureImages: [],
  modelLink: "https://disk.yandex.ru/d/GaHZo6es1RYaTw",
  passportImages: [],
  downloadLink: "https://disk.yandex.ru/d/GaHZo6es1RYaTw",
  clientImages: []
  },
  
  
   {
    slug: "kitchen_1",
    title: "Кухня угловая с выдвижной столешницей",
    preview: "https://s4.iimage.su/s/05/u5aocTsxRvlSsWTphO5OSejvNXzG4IpZvmd7AZ6e.webp",
    category: "model",
  description: "Корпус ЛДСП, фасады и видимые части корпуса МДФ+эмаль, столешница МДФ+шпон",
  modelImages: [ "https://s4.iimage.su/s/05/u5aocTsxRvlSsWTphO5OSejvNXzG4IpZvmd7AZ6e.webp", "https://s4.iimage.su/s/05/ukbL382xh49lkT8s3gvzz00Q6VSib2S92yADNna7.webp", "https://s4.iimage.su/s/05/u9nwiCDxV5Od6wNXyPN96DBmfd4sUBHTEWMMMOIX.jpg"]
  ,  measureImages: [],
  modelLink: "",
  passportImages: [],
  downloadLink: "",
  clientImages: []
  },  

  {
    slug: "shkaf",
    title: "Прихожая",
    preview: "https://s4.iimage.su/s/26/uR6acsixZvJWF5wN8eS4Jq23aTrZwv5O6kJ7rjRI.jpg",
    category: "client",
  description: "",
  modelImages: [ ]
  ,  measureImages: [],
  modelLink: "",
  passportImages: [],
  downloadLink: "https://disk.yandex.ru/i/0AhCLwvZApCU_Q",
  clientImages: ["https://s4.iimage.su/s/26/uNbLF2jx7Gl9eomsuUJaeBwq2Y0Z0AP0ZL9lBzwN.jpg", "https://s4.iimage.su/s/26/uZCCTl7xNEqpy66FRV4iU2mRb6R5zhA0gcVizUuP.jpg", "https://s4.iimage.su/s/26/ud0WsT5xew0DwbHbZ7sb9DCbWwkCbSr0LKz8We97.jpg", "https://s4.iimage.su/s/26/utDJDinxIKBBrkDSSB8HSmiN7qwT2dTlITTIAHCa.jpg"]
  },  

 {
    slug: "tv-tumba",
    title: "ТВ-тумба",
    preview: "https://s4.iimage.su/s/26/u8DzP1txWSY5Q8pFmqwZZgfNQBgS44jevtyoVL4d.png",
    category: "pasport",
  description: "",
  modelImages: [ ]
  ,  measureImages: [],
  modelLink: "",
  passportImages: ["https://s4.iimage.su/s/26/u8DzP1txWSY5Q8pFmqwZZgfNQBgS44jevtyoVL4d.png", "https://s4.iimage.su/s/26/u4wufdhxg5YaKNbRKqMpe5qfIb4tFlomWA1lSz7h.png", "https://s4.iimage.su/s/26/unosLUixFucHt7RUywk4OfuzeIGUUljKaz85uKqY.png", "https://s4.iimage.su/s/26/u4sVwu4xo5Z1fcbz4OqJRSPMqdLkgO64940kLRdC.png"],
  downloadLink: "https://disk.yandex.ru/i/oZnGqzZuzke9sA",
  clientImages: []
  }, 

];

  /*{ id: "model", label: "Модели Базис мебельщик" },
  { id: "foto", label: "Фото проектов" },
  { id: "pasport", label: "Паспорта для сборки" },
  { id: "client", label: "Чертежи для согласования" },*/